@if(advisorList().length > 0){
<div class=" mx-auto px-4 sm:px-6 lg:px-8 mt-8 mb-8 animate-fade-in">
  <h2 class="text-4xl font-extrabold text-gray-900 mb-6 pb-2 relative">
    <span
      class="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-500"
    >
      CircledPlus Advisors
    </span>
    <span class="block text-base font-medium text-gray-500 mt-1">
      (Showing {{ advisorList().length }} Active Advisors)
    </span>
    <div
      class="absolute bottom-0 left-0 w-16 h-1 bg-indigo-500 rounded-full"
    ></div>
  </h2>

  <div
    class="mb-10 p-5 bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col sm:flex-row gap-4 items-center transition-all duration-300"
  >
    <div class="relative flex-grow w-full sm:w-auto">
      <input
        type="text"
        (input)="onSearch($event)"
        placeholder="Search by name, expertise, or firm..."
        class="w-full py-2 pl-12 pr-4 border-2 border-gray-200 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200 shadow-inner hover:shadow-md"
      />
      <svg
        class="absolute left-3 top-1/2 transform -translate-y-1/2 h-6 w-6 text-indigo-400"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
    <button
      type="button"
      class="w-full sm:w-auto flex items-center justify-center px-6 py-2.5 text-base font-semibold rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:ring-indigo-300 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
    >
      <svg
        class="w-5 h-5 mr-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
        />
      </svg>
      Specialization Filters
    </button>
  </div>

  <div class="grid grid-cols-1 gap-6 sm:hidden">
    @for (advisor of advisorList(); track advisor._id) {
    <div
      class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden animate-fade-in"
    >
      <div class="p-4 flex items-center space-x-4">
        <img
        [src]="advisor.advisorImg || 'assets/img/user.jpeg'"
          class="h-16 w-16 rounded-full object-cover border-2 border-white shadow-md"
        />
        <div>
          <h3 class="text-lg font-extrabold text-gray-900">
            {{ advisor.name | slice : 0 : 20 }}
          </h3>
          <p class="text-indigo-600 text-sm font-medium">
            {{ advisor.specialization }}
          </p>
        </div>
      </div>
      <div
        class="px-4 py-3 bg-gray-50 flex justify-between text-xs font-bold text-gray-600"
      >
        <span>📍 {{ advisor.location }}</span>
        <span>💼 {{ advisor.experience }}</span>
      </div>
      <div class="p-4">
        <button
          (click)="viewDetails(advisor._id)"
          class="w-full py-2 text-sm font-semibold rounded-lg text-white bg-indigo-600"
        >
          View Full Profile
        </button>
      </div>
    </div>
    }
  </div>

  <div
    class="hidden sm:block shadow-sm overflow-hidden rounded-2xl bg-white border border-gray-100 animate-fade-in-slow"
  >
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-indigo-50">
        <tr class="text-xs font-medium tracking-wider text-gray-500 uppercase">
          <th scope="col" class="px-6 py-3 text-left">Advisor / Firm</th>
          <th scope="col" class="px-6 py-3 text-left">Specialization</th>
          <th scope="col" class="px-6 py-3 text-center">Assigned Properties</th>
          <th scope="col" class="px-6 py-3 text-left">Role</th>
          <th scope="col" class="px-6 py-3 text-center">Availability</th>
          <th scope="col" class="px-6 py-3 w-28 text-center">Actions</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        @for (item of advisorList(); track item._id) {
        <tr class="hover:bg-indigo-50 transition-colors duration-300 group">
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <img
                 [src]="item?.advisorImg || 'user.jpeg'"
                 class="h-10 w-10 rounded-full object-cover border border-gray-100"
                 alt="Advisor Profile"
                />
              <div class="ml-4">
                <p class="text-base font-bold text-gray-900">{{ item.name | slice : 0 : 20}}</p>
                <p class="text-xs text-gray-500">{{ item.email }}</p>
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span
              class="px-2 py-1 text-xs font-bold rounded bg-indigo-100 text-indigo-700"
            >
              {{ item.specialization }}
            </span>
          </td>
          <td
            class="px-6 py-4 whitespace-nowrap text-center text-sm font-bold text-gray-700"
          >
            {{ item.assignedProperties }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-left">
            <p class="text-lg font-extrabold text-green-700">
                <!-- {{ item.priceUnit }} -->
               {{ item.role.label }}
            </p>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-center">
            <span
              class="bg-green-100 text-green-800 px-3 py-1 text-xs font-semibold rounded-full"
            >
              Online
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-center">
            <div class="flex justify-center items-center space-x-3">
              <!-- <button
                class="p-2 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-lg transition-all"
                title="Book Appointment"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </button> -->
            
              <button
                (click)="viewProfile(item)"
                class="px-3 py-2 text-xs font-bold border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-600 hover:text-white transition-all"
              >
                Profile
              </button>
              <!-- (click)="deleteAdvisor(item._id)" -->
              <button
                (click)="openDeleteModal(item._id)"
                class="p-2 text-red-500 hover:bg-red-500 hover:text-white rounded-lg transition-all"
                title="Delete"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
} @else {

<div class="mx-auto px-4 sm:px-6 lg:px-8">
  <div
    class="w-full text-center bg-white py-20 px-10 rounded-3xl border border-gray-100 shadow-sm shadow-indigo-50/50 transform transition-all animate-fade-in-slow"
  >
    <div class="relative mx-auto w-24 h-24 mb-6">
      <div
        class="absolute inset-0 bg-indigo-100 rounded-full animate-pulse opacity-50"
      ></div>

      <div
        class="relative flex items-center justify-center w-full h-full bg-indigo-50 rounded-full border-2 border-white shadow-inner"
      >
        <svg
          class="w-12 h-12 text-indigo-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2m-7 7h-2"
          ></path>
        </svg>
      </div>
    </div>

    <h3 class="text-3xl font-extrabold text-gray-900 mb-3 leading-tight">
      No Advisors Found
    </h3>
    <p class="text-gray-500 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
      We couldn't find any professionals matching your current search or
      filters. Try broadening your search criteria or clearing all active
      filters.
    </p>

    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <button
        class="px-8 py-3.5 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl shadow-lg shadow-indigo-200 transition-all duration-300 transform hover:-translate-y-0.5 active:scale-95"
      >
        Clear All Filters
      </button>
      <button
        class="px-8 py-3.5 bg-white border-2 border-gray-200 hover:border-indigo-100 hover:bg-indigo-50 text-gray-600 hover:text-indigo-600 font-bold rounded-xl transition-all duration-300"
      >
        Contact Support
      </button>
    </div>
  </div>
</div>
}


@if (isDeleteModalOpen) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">

    <div class="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6">

      <div class="w-14 h-14 mx-auto mb-4 rounded-full bg-red-50 flex items-center justify-center">
        <svg class="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>

      <h3 class="text-xl font-bold text-center mb-2">
        Confirm Deletion
      </h3>

      <p class="text-gray-600 text-center mb-6">
        Are you sure you want to delete this advisor?  
        This action cannot be undone.
      </p>

      <div class="flex gap-3">

        <button 
          (click)="closeDeleteModal()"
          class="flex-1 border border-gray-300 py-2 rounded-full hover:bg-gray-50">
          Cancel
        </button>

        <button 
          (click)="confirmDelete()"
          class="flex-1 bg-red-600 text-white py-2 rounded-full hover:bg-red-700">
          Delete
        </button>

      </div>

    </div>

  </div>
}